import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Layout } from '@stashinvest/ui';
import {
	getDebitEnrollmentConfirmationData,
	confirmDebitEnrollment,
	setDebitConfirmAddress,
	setDebitConfirmInfo,
} from 'stash/actions';
import {
	reviewInformationScreenCta,
	reviewInformationScreenEdit,
	addressErrorScreenView,
	addressErrorCta,
	addressErrorSecondaryCta,
	addressOrNameErrorScreenView,
	addressOrNameErrorCta,
	addressOrNameErrorSecondaryCta,
} from 'stash/actions/debitSignUpTrackingEvents';
import ConfirmInfoScreen from './ConfirmInfoScreen';
import { AddressErrorScreen, NameErrorScreen } from './BankErrorScreen';

const mapStateToProps = (state) => {
	return {
		address: state.application.debitSignUp.address,
		confirmationData: state.entities.bank.confirmationData,
	};
};

const mapDispatchToProps = {
	getConfirmationData: getDebitEnrollmentConfirmationData,
	confirmEnrollment: confirmDebitEnrollment,
	setDebitConfirmAddress,
	setDebitConfirmInfo,
	reviewInformationScreenCta,
	reviewInformationScreenEdit,
	addressErrorScreenView,
	addressErrorCta,
	addressErrorSecondaryCta,
	addressOrNameErrorScreenView,
	addressOrNameErrorCta,
	addressOrNameErrorSecondaryCta,
};

export function DebitSignUpConfirmInfoScreen(props) {
	const {
		address,
		confirmationData,
		getConfirmationData,
		confirmEnrollment,
		setDebitConfirmAddress,
		setDebitConfirmInfo,
		completeStep,
		reviewInformationScreenCta,
		reviewInformationScreenEdit,
		addressErrorScreenView,
		addressErrorCta,
		addressErrorSecondaryCta,
		addressOrNameErrorScreenView,
		addressOrNameErrorCta,
		addressOrNameErrorSecondaryCta,
	} = props;

	const [error, setError] = useState();
	const [isPosting, setIsPosting] = useState();
	const clearError = () => setError(null);

	const handleEditAddressClick = () => {
		reviewInformationScreenEdit();
		setDebitConfirmAddress(false);
		return completeStep();
	};

	const handleConfirmEnrollment = () => {
		setIsPosting(true);
		reviewInformationScreenCta();

		return confirmEnrollment(address)
			.then(() => {
				setDebitConfirmInfo(true);
				return completeStep();
			})
			.catch(({ errors }) => {
				setIsPosting(false);
				setError(errors[0].code);
			})
			.finally(() => setIsPosting(false));
	};

	useEffect(() => {
		if (!confirmationData) {
			getConfirmationData();
		}
	}, [confirmationData, getConfirmationData]);

	return error === 6 ? (
		<AddressErrorScreen
			onMount={addressErrorScreenView}
			ctaCallback={addressErrorCta}
			secondaryCtaCallback={() => {
				clearError();
				addressErrorSecondaryCta();
			}}
		/>
	) : error === 7 ? (
		<NameErrorScreen
			onMount={addressOrNameErrorScreenView}
			ctaCallback={addressOrNameErrorCta}
			secondaryCtaCallback={() => {
				clearError();
				addressOrNameErrorSecondaryCta();
			}}
		/>
	) : !confirmationData ? (
		<Layout.PageWrapLoader />
	) : (
		<ConfirmInfoScreen
			{...address}
			{...confirmationData}
			isPosting={isPosting}
			handleEditClick={handleEditAddressClick}
			handleCtaClick={handleConfirmEnrollment}
		/>
	);
}

DebitSignUpConfirmInfoScreen.defaultProps = {
	getConfirmationData: () => {},
	confirmEnrollment: () => Promise.resolve(),
	completeStep: () => {},
	setDebitConfirmAddress: () => {},
	setDebitConfirmInfo: () => {},
};

DebitSignUpConfirmInfoScreen.propTypes = {
	address: PropTypes.object,
	confirmationData: PropTypes.object,
	getConfirmationData: PropTypes.func.isRequired,
	confirmEnrollment: PropTypes.func.isRequired,
	completeStep: PropTypes.func.isRequired,
	setDebitConfirmAddress: PropTypes.func.isRequired,
	setDebitConfirmInfo: PropTypes.func.isRequired,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DebitSignUpConfirmInfoScreen);
